// extracted by mini-css-extract-plugin
module.exports = {"zoomerContainer":"Zoomer_zoomerContainer__lhxqr","zoomer":"Zoomer_zoomer__AgJDv","zoomerQuestion":"Zoomer_zoomerQuestion__1CIB5","zoomerDetails":"Zoomer_zoomerDetails__zBtNv"};